import React from 'react'
import 'react-horizontal-scrolling-menu/dist/styles.css';

import { useContext, useEffect, useState, useRef } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import { isMobile } from 'react-device-detect';
import Card from '../UI/Card';
import SeeMoreOffers from '../SeeMoreOffers/SeeMoreOffers'
import classes from "./Offers.module.css";
import OfferContext from '../../store/OfferContext';
import CurrencySelector from '../CurrencySelector/CurrencySelector';
import CurrencyContext from '../../store/CurrencyContext';
import useEmblaCarousel from 'embla-carousel-react'
import LanguageSelector from '../LanguageSelector/LanguageSelector';

const Offers = (props) => {
    const offerCtx = useContext(OfferContext)
    const currencyCtx = useContext(CurrencyContext)
    const [resetKey, setResetKey] = useState(Date.now());
    const [countryHasOffer, setcountryHasOffer] = useState(false);
    const [offersList, setoffersList] = useState();
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, watchSlides: true, dragFree: false })
    const [location, setLocation] = useState();
    const [buttonIsActive, setButtonIsActive] = useState(false);
    const [selectedCountryEnglishNames, setSelectedCountryEnglishNames] = useState([]);
    const [resetText, setResetText] = useState('');
    const [noOfferText, setNoOfferText] = useState('');
    const [filteredList, setFilteredList] = useState([]);
    const lastRemovedCountryRef = useRef(null);
    const previousCountriesRef = useRef([]);

    // --------------------
    // i18n causing maximum update depth exceeded in this component only, to investigate
    // const {t, i18n} = useTranslation('common');
    // --------------------

    // Const & Variables
    const selectedCountries = offerCtx.selectedCountries
    const selectedCapacity = offerCtx.selectedCapacity
    const selectedValidity = offerCtx.selectedValidity
    const currentConversionRate = currencyCtx.currentConversionRate
    const selectedCurrency = currencyCtx.selectedCurrency
    const currencies = currencyCtx.loadedCurrencies
    const languageParentWindow = currencyCtx.languageParentWindow
    const allCountries = offerCtx.loadedCountries
    const referalCode = offerCtx.referalCode
    const referal = offerCtx.referal
    const maxNbreOfOffers = 18;
    const videotronData = {
        id: "VTRN-001",
        job_id: "manual_injected",
        createdAt: "2024-04-29T00:00:00Z",
        provider: "Videotron",
        planName: "Canada & Int",
        dataAmount: 45000,
        validity: "30", 
        currency: "CAD",
        price: 80,
        slug: "videotron_45gb_30days",
        urlEn: "https://www.planhub.ca/en/searchngo/mobile?link=https%3A%2F%2Fwww.videotron.com%2Fen%2Fmobile%2Fcell-phone-plans%2F1-canada-international-plan",
        urlFr: "https://www.planhub.ca/en/searchngo/mobile?link=https%3A%2F%2Fwww.videotron.com%2Fmobilite%2Fforfaits-cellulaire%2F1-forfait-canada-international",
        backupUrl: "https://videotron.com",
        countries: {"0":"ABW","1":"AIA","2":"ARE","3":"ARG","4":"ATG","5":"AUS","6":"AUT","7":"BEL","8":"BES","9":"BFA","10":"BGD","11":"BGR","12":"BHS","13":"BMU","14":"BRA","15":"BRB","16":"CAN","17":"CHE","18":"CHL","19":"CHN","20":"COD","21":"COL","22":"CRI","23":"CUB","24":"CUW","25":"CYM","26":"CZE","27":"DEU","28":"DMA","29":"DNK","30":"DOM","31":"DZA","32":"ECU","33":"EGY","34":"ESP","35":"EST","36":"FIN","37":"FRA","38":"GBR","39":"GGY","40":"GHA","41":"GLP","42":"GRC","43":"GRD","44":"GUF","45":"GUY","46":"HRV","47":"HTI","48":"HUN","49":"IDN","50":"IMN","51":"IND","52":"IRL","53":"ISL","54":"ISR","55":"ITA","56":"JAM","57":"JEY","58":"JOR","59":"JPN","60":"KNA","61":"KOR","62":"KWT","63":"LCA","64":"LKA","65":"LTU","66":"LUX","67":"LVA","68":"MAF","69":"MAR","70":"MEX","71":"MNE","72":"MSR","73":"MTQ","74":"MYS","75":"NGA","76":"NLD","77":"NOR","78":"NZL","79":"PAK","80":"PAN","81":"PER","82":"PHL","83":"POL","84":"PRI","85":"PRT","86":"QAT","87":"ROU","88":"SGP","89":"SLV","90":"SVK","91":"SVN","92":"SWE","93":"SXM","94":"TCA","95":"THA","96":"TTO","97":"TUN","98":"TUR","99":"TWN","100":"USA","101":"UZB","102":"VAT","103":"VCT","104":"VGB","105":"VIR","106":"VNM","107":"ZAF","108":"COG"}       
    };

    useEffect(() => {
        if (previousCountriesRef.current.length > 0 && selectedCountries.length === 0) {
            const removed = previousCountriesRef.current.find(
                code => !selectedCountries.includes(code)
            );
            lastRemovedCountryRef.current = removed;
        }
        previousCountriesRef.current = [...selectedCountries];
    }, [selectedCountries]);    

    // Decide how many offers to display (mobile vs desktop)
    let nbreOffersDisplayed = isMobile ? maxNbreOfOffers : offerCtx.nbreOffersDisplayed;
    // const getCountryISO3 = require("country-iso-2-to-3");

    const compareByPrice = (a, b) => a.price - b.price

    //Sorting data so they appear by ascending price
    const sortedData = offerCtx.data.sort(compareByPrice)

    const convertToGB = (capacity) => {
        if (capacity !== undefined && capacity !== null) {
            capacity /= 1000
        }
        return capacity;
    }

    const uniqueData = sortedData;
    const handleReset = () => {
        setResetKey(Date.now());
        props.onResetKey(resetKey)
    };

    const resetField = () => {
        offerCtx.changeCapacity(null);
        offerCtx.changeValidity(null);
        offerCtx.changeCountries(offerCtx.selectedCountries)

        handleReset()
    }

    const seeMoreOffers = () => {
        offerCtx.changeNberOffers(nbreOffersDisplayed + 3)
    }

    const [isFromQuebec, setIsFromQuebec] = useState(false);

    const fetchRegion= async () => {
        try {
            const response = await fetch("https://www.planhub.ca/ip-information?dyn=1");
            const data = await response.json();
            if (data.region && data.region.toLowerCase() === "quebec") {
                setIsFromQuebec(true);
            } else {
                setIsFromQuebec(false);
            }              
        } catch (error) {
            console.error("Erreur récupération de la région");
        }        
    };

    useEffect(() => {
        fetchRegion();
    }, []);

    useEffect(() => {
        const selectedCountriesNames = selectedCountries.map(countryCode =>
            allCountries.find(country =>
                country.code === countryCode.toUpperCase()
            )
        );
    
        if (offerCtx.isLoaded && selectedCountries.length >= 0) {
            if (selectedCountries.length === 0) {
                setcountryHasOffer(false);
            } else {
                const selectedCountryFrenchNames = selectedCountriesNames.map((country) => country.nameFrench.common);
                setSelectedCountryEnglishNames(selectedCountriesNames.map((country) => country.name));
    
                if (languageParentWindow === 'fr') {
                    setLocation(
                        (selectedCountryFrenchNames.length > 1)
                            ? selectedCountryFrenchNames[0] + ` + ${selectedCountryFrenchNames.length - 1}`
                            : selectedCountryFrenchNames[0]
                    );
                    setResetText("Réinitialiser capacité et durée");
                    setNoOfferText("Aucune offre à afficher - Sélectionnez un autre pays, ou réinitialisez la capacité et la durée");
                } else if (languageParentWindow === 'en') {
                    setLocation(
                        (selectedCountryEnglishNames.length > 1)
                            ? selectedCountryEnglishNames[0] + ` + ${selectedCountryEnglishNames.length - 1}`
                            : selectedCountryEnglishNames[0]
                    );
                    setResetText("Reset capacity and duration");
                    setNoOfferText("No offer to show - Select another Country or reset Capacity and Duration");
                }
    
                function extractCountries(serializedString) {
                    const countriesRegex = /"([^"]*)"/g;
                    const matches = serializedString.match(countriesRegex);
                    if (matches) {
                        return matches.map(country => country.replace(/"/g, ''));
                    }
                    return [];
                }
    
                setcountryHasOffer(uniqueData.some((element) => {
                    return selectedCountries.every(countryCode => Object.values(element.countries).includes(countryCode));
                }));
    
                const uniqueProviders = [];
                for (const plan of uniqueData) {
                    if (!uniqueProviders.includes(plan.provider)) {
                        uniqueProviders.push(plan.provider);
                    }
                }
    
                const updatedFilteredList = uniqueData.filter(offer => {
                    const capacity = convertToGB(offer.dataAmount);
                    const extractedCountries = extractCountries(offer.countries);
    
                    let iso3Country = extractedCountries;
    
                    if (
                        (offer.provider === "RedTeaGo" && offer.planName === "eSIM Trial")
                        || (offer.provider === "Saily" && offer.urlEn === "https://saily.com/")
                    ) {
                        return false;
                    }
    
                    if (!iso3Country) {
                        return false;
                    }
    
                    if (typeof iso3Country === 'string') {
                        iso3Country = [iso3Country];
                    }
    
                    const countryMatch = selectedCountries.every(countryCode => iso3Country.includes(countryCode));
                    const capacityMatch = capacity >= convertToGB(offerCtx.selectedCapacity) || !offerCtx.selectedCapacity;
                    const validityMatch = parseFloat(offer.validity) >= parseFloat(offerCtx.selectedValidity) || !offerCtx.selectedValidity;
                    const providerMatch = offer.provider === offerCtx.provider;
    
                    return (offerCtx.provider === "" || !uniqueProviders.includes(offerCtx.provider))
                        ? countryMatch && capacityMatch && validityMatch
                        : countryMatch && capacityMatch && validityMatch && providerMatch;
                });
    
                setFilteredList(updatedFilteredList);
            }
        }
    
        if (offerCtx.isLoaded) {
            if (filteredList.length > 0 && !countryHasOffer) {
                let videotronConvertedPrice = videotronData.price;

                const conversionRates = currencyCtx.conversionRates;
                
                if (
                  selectedCurrency !== "CAD" &&
                  conversionRates &&
                  conversionRates["CAD"] &&
                  conversionRates[selectedCurrency]
                ) {
                  const cadToUsd = conversionRates["CAD"]; // 1 USD = X CAD
                  const rateToTarget = conversionRates[selectedCurrency];
                
                  // Convertir 80 CAD → USD → targetCurrency
                  const priceInUsd = videotronData.price / cadToUsd;
                  videotronConvertedPrice = priceInUsd * rateToTarget;
                }
                

                const videotronCardProps = {
                    id: videotronData.id,
                    key: videotronData.id,
                    logo: process.env.PUBLIC_URL + "/assets/logo/videotron-100x100.jpg",
                    provider: "Videotron",
                    capacity: convertToGB(videotronData.dataAmount),
                    planName: videotronData.planName,
                    location: location,
                    country: selectedCountryEnglishNames[0],
                    price: videotronConvertedPrice.toFixed(2),
                    validity: videotronData.validity,
                    referal: referal,
                    url: languageParentWindow === 'fr' ? videotronData.urlFr : videotronData.urlEn,
                    backupUrl: videotronData.backupUrl,
                    currencySymbol: currencies[selectedCurrency]?.Symbol || ''
                };
            
                const videotronCard = (
                    <React.Fragment key={videotronData.id}>
                        {isMobile ? (
                            <div className={classes.embla__slide}>
                                <Card {...videotronCardProps} />
                            </div>
                        ) : (
                            <Card {...videotronCardProps} />
                        )}
                    </React.Fragment>
                );

                const videotronCountries = Object.values(videotronData.countries);
                const isFromProtegezVous = document.referrer.includes("protegez-vous.ca");

                const showVideotron =
                    isFromQuebec &&
                    !isFromProtegezVous &&
                    (
                        selectedCountries.length > 0
                        ? selectedCountries.every(code => videotronCountries.includes(code))
                        : videotronCountries.includes(lastRemovedCountryRef.current)
                    );
            
                const otherCards = filteredList.slice(0,  showVideotron ? nbreOffersDisplayed - 1 : nbreOffersDisplayed).map((offer) => {
                    let trimmedPlanName = offer.planName + " ";
                    trimmedPlanName = trimmedPlanName.substring(0, 22);
                    trimmedPlanName = trimmedPlanName.substring(0, Math.min(trimmedPlanName.length, trimmedPlanName.lastIndexOf(" ")));
            
                    const lastCharacter = trimmedPlanName.charAt(trimmedPlanName.length - 1);

                    if (!lastCharacter.match(/[a-zA-Z0-9]/)) {
                        trimmedPlanName = trimmedPlanName.substring(0, trimmedPlanName.length - 1);
                    }
            
                    let providerUrl = null;
                    let logo = null;
                    let adjustedUrl = null;
            
                    switch (offer.provider) {
                        case 'Airalo':
                            adjustedUrl = languageParentWindow === 'fr' ? offer.urlFr : offer.urlEn;
                            providerUrl = `https://airalo.pxf.io/simbud?subId1=${referal}&p.code=${referalCode}&u=${adjustedUrl}`;
                            logo = process.env.PUBLIC_URL + "/assets/logo/airalo-100x100.png";
                            break;

                        case 'Flexiroam':
                            providerUrl = `https://flexiroamlimited.sjv.io/e116ZO?subId1=${referal}&u=${offer.urlEn}`;
                            logo = process.env.PUBLIC_URL + "/assets/logo/flexiroam-100x100.png";
                            break;

                        case 'Nomad':
                            providerUrl = `${offer.urlEn}?rfsn=6805394.b005bf&subid=${referal}`;
                            logo = process.env.PUBLIC_URL + "/assets/logo/nomad-100x100.png";
                            break;

                        case "RedTeaGo":
                            providerUrl = `https://esim.redteago.com/&subid=${referal}`;
                            logo = process.env.PUBLIC_URL + "/assets/logo/redteago-100x100.png";
                            break;

                        case "Esimatic":
                            providerUrl = `https://esimsia.sjv.io/LKKQdM?irclickid=WDIWczQg5xyPRKG3nu2PQS7-UkHUWu2%3AwVq6yc0&sharedid&irpid=3581881&irgwc=1&subId1=${referal}`;
                            logo = process.env.PUBLIC_URL + "/assets/logo/esimatic-100x100.png";
                            break;

                        case "Saily":
                            providerUrl = offer.urlEn + `&aff_sub=${referal}&subId1=${referal}`;
                            logo = process.env.PUBLIC_URL + "/assets/logo/saily-100x100.png";
                            break;

                        case "Gigsky":
                            providerUrl = `https://gigsky.pxf.io/4GG1Ao?&aff_sub=${referal}&subId1=${referal}`;
                            logo = process.env.PUBLIC_URL + "/assets/logo/gigsky-100x100.png";
                            break;

                        case "Esim4travel":
                            providerUrl = `https://esim4travel.pxf.io/xLL761?&aff_sub=${referal}&subid=${referal}&subid1=${referal}`;
                            logo = process.env.PUBLIC_URL + "/assets/logo/esim4travel-100x100.png";
                            break;

                        case "AlwaysMobile":
                            providerUrl = languageParentWindow === 'fr' ? offer.urlFr + `?sca_ref=7634519.U6fYyrxevLrRHteG&sca_source=${referal}` : offer.urlEn + `?sca_ref=7634519.U6fYyrxevLrRHteG&sca_source=${referal}`;
                            logo = process.env.PUBLIC_URL + "/assets/logo/alwaysmobile-100x100.png";
                            break;

                        case "Ubigi":
                            providerUrl = languageParentWindow === 'fr' ? offer.urlFr + `?subId1=${referal}` : offer.urlEn + `?subId1=${referal}`;
                            logo = process.env.PUBLIC_URL + "/assets/logo/ubigi-100x100.png";
                            break;
                        
                        case "Instabridge":
                            providerUrl = languageParentWindow === 'fr' ? offer.urlFr + `?subId1=${referal}` : offer.urlEn + `?subId1=${referal}`;
                            logo = process.env.PUBLIC_URL + "/assets/logo/instabridge-100x100.png";
                            break;

                        case "Firsty":
                            providerUrl = `https://firsty.sjv.io/aO5zko`;
                            logo = process.env.PUBLIC_URL + "/assets/logo/firsty-100x100.png";
                            break;

                        default:
                            console.warn('No provider');
                    }
            
                    const cardProps = {
                        id: offer.id,
                        key: offer.id,
                        logo: logo,
                        provider: offer.provider === "AlwaysMobile" ? "Always Mobile" : offer.provider,
                        capacity: convertToGB(offer.dataAmount),
                        planName: trimmedPlanName,
                        location: location,
                        country: selectedCountryEnglishNames[0],
                        price: (Math.round(offer.price * currentConversionRate * 100) / 100).toFixed(2),
                        validity: offer.validity,
                        referal: referal,
                        url: providerUrl,
                        backupUrl: offer.backupUrl,
                        currencySymbol: currencies[selectedCurrency]?.Symbol || ''
                    };
            
                    return (
                        <React.Fragment key={offer.id}>
                            {isMobile ? (
                                <div className={classes.embla__slide}>
                                    <Card {...cardProps} />
                                </div>
                            ) : (
                                <Card {...cardProps} />
                            )}
                        </React.Fragment>
                    );
                });
            
                setoffersList(showVideotron
                    ? [videotronCard, ...otherCards]
                    : otherCards
                  );
                  
                const totalFilteredCount = filteredList.length;
                const hasMoreOffers = totalFilteredCount > nbreOffersDisplayed;
                const stillUnderMax = nbreOffersDisplayed < maxNbreOfOffers;
                setButtonIsActive(hasMoreOffers && stillUnderMax);

                if (offersList) {
                    props.onSendData(offersList.length);
                }
            } else {
                setoffersList(
                    <>
                        <span className={classes.hideSmallScreens}> </span>
                        <div className={classes.errorContainer}>
                            <BrowserView>
                                {!countryHasOffer && <button className={classes.resetButton} onClick={resetField}>{resetText}</button>}
                                {!countryHasOffer && <p>{noOfferText}</p>}
                            </BrowserView>
                            <MobileView>
                                <div className={classes.noOfferMobile}>
                                    {!countryHasOffer && <button className={classes.resetButton} onClick={resetField}>{resetText}</button>}
                                    {!countryHasOffer && <p>{noOfferText}</p>}
                                </div>
                            </MobileView>
                        </div>
                    </>
                );
    
                setButtonIsActive(false);
    
                if (offersList) {
                    props.onSendData(offersList.length);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCountries, offerCtx, countryHasOffer, location, selectedCapacity, selectedValidity, filteredList]);

    useEffect(() => {
        if (emblaApi) {
            emblaApi.scrollTo(0);
        }
    }, [selectedCountries, selectedCapacity, selectedValidity, emblaApi]);

    return (
        <div className={`${classes.mainContainer} ${isMobile ? classes.mainContainerMobile : ''}`}>

            <BrowserView className={classes.mainContainer}>
                <div className={classes.proposal_plans}>
                    {offersList}
                </div>
                <div className={classes.offersNCurrencyContainer}>
                {buttonIsActive && (<SeeMoreOffers onClickMoreOffers={seeMoreOffers} buttonIsActive={true} />)}
                    <CurrencySelector />
                    <LanguageSelector />
                </div>
            </BrowserView>
            <MobileView className={classes.mobileViewContainer}>
                <div className={classes.embla} ref={emblaRef}>
                    <div className={classes.embla__container}>
                        {offersList}
                    </div>
                </div>
                <div className={`${classes.offersNCurrencyContainer} ${classes.mobileCurrency}`}>
                    <CurrencySelector />
                    <LanguageSelector />
                </div>
            </MobileView>


        </div>
    )
}

export default Offers; 